import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { propType } from 'graphql-anywhere';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

import { querySelector } from '../../utils';
import {
  invalidTicketNumberPrefix,
} from '../../features/fields/TicketInput';

export class TicketInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchTerm: '',
      error: null,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearErrorState = this.clearErrorState.bind(this);
  }

  UNSAFE_componentWillReceiveProps(ownProps) {
    const { selectedItem } = this.props;

    if (selectedItem && (selectedItem.id !== ownProps.selectedItem.id)) {
      this.props.data.refetch();
      /* NOTE: Clear error when something new is selected */
      this.clearErrorState();
    }
  }

  clearErrorState() {
    this.setState({ error: null });
  }

  handleCancel() {
    this.handleChange(null);
    this.clearErrorState();
  }

  handleChange(value) {
    this.props.onChange({
      target: {
        name: this.props.name,
        value,
      },
    });
    this.clearErrorState();
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  render() {
    const { tickets, value, disabled } = this.props;
    const { open, searchTerm, error } = this.state;
    return (
      <div>
        <InputGroup>
          {
            /*
              The on mouse down prevents the 'onClick' from firing.
              This was toggling the dropdown
              twice. If you have a better way of prevent
              the double toggle by all means implement it.
            */
          }
          <DropdownList
            disabled={disabled}
            inputProps={{
              className: 'form-control',
            }}
            filter="contains"
            value={value}
            data={tickets}
            open={open}
            onFocus={this.handleOnFocus}
            onToggle={this.handleOnToggle}
            onChange={this.handleChange}
            searchTerm={searchTerm}
            onSearch={(term) => {
              this.setState({
                searchTerm: term.toUpperCase(),
              });

              if (invalidTicketNumberPrefix(term)) {
                this.setState({
                  error: 'Invalid ticket number prefix',
                });
              } else {
                this.clearErrorState();
              }
            }}
            onMouseDown={(e) => { e.preventDefault(); }}
            valueField="id"
            textField="number"
          />
          <InputGroup.Button>
            <Button
              name="cancel"
              tabIndex="-1"
              disabled={!value}
              onClick={this.handleCancel}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
        <span className="form-error">
          {error}
        </span>
      </div>
    );
  }
}

const TicketInputTicketFragment = gql`
  fragment TicketInputTicket on TicketNumber {
    id
    number
  }
`;

export const AllTicketsQuery = gql`
  query AllTicketNumbers($assigned: TicketNumberAssignedTypes){
    all_ticket_numbers(assigned: $assigned) {
      edges {
        node {
          ...TicketInputTicket
        }
      }
    }
  }
  ${TicketInputTicketFragment}
`;

const CreateTicketMutation = gql`
  mutation CreateTicket($input: TicketNumberCreateInput!) {
    ticket_number_create(input: $input) {
      ...TicketInputTicket
    }
  }
  ${TicketInputTicketFragment}
`;

const propTypes = exact({
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: propType(TicketInputTicketFragment),
  onChange: PropTypes.func.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  assigned: PropTypes.string,
  data: PropTypes.object,
  tickets: PropTypes.arrayOf(propType(TicketInputTicketFragment)).isRequired,
  createTicket: PropTypes.func.isRequired,
});

const defaultProps = {
  disabled: false,
  value: null,
  assigned: 'all',
};

TicketInput.propTypes = propTypes;
TicketInput.defaultProps = defaultProps;

export const marshallData = ({ data, ownProps }) => {
  const tickets = querySelector(data, '$.all_ticket_numbers.edges[*].node', []);
  return {
    ...ownProps,
    data,
    tickets,
  };
};

const queryVariables = (props) => {
  const { assigned } = props;
  return {
    fetchPolicy: 'network-only',
    variables: {
      assigned,
    },
  };
};

const withApi = compose(
  graphql(AllTicketsQuery, {
    props: marshallData,
    options: queryVariables,
  }),
  graphql(CreateTicketMutation, { name: 'createTicket' }),
);

export default withApi(TicketInput);
